import type { SolAnchor } from '@/shared/lib/format';
import * as s from './TodaySealedTitle.css';

export interface TodaySealedTitleProps {
  /** 오늘의 entry 번호 (placeholder OK — 백엔드 SEAL counter 도입 전) */
  entryNo: number;
  /**
   * N일째와 그 일수의 기준(`solAnchor`). 미주입 시 일째 영역 숨김.
   * day만 받지 않는 이유 — 기준 없는 숫자는 정규직 전환일 기준으로 읽힌다(제보 #121).
   */
  sol?: SolAnchor;
}

/**
 * Daily Sealed Log motif title — DesktopWindow `titleSlot` prop에 주입.
 * 한글 친근화: `오늘 일지 · 142번째 · 입사 127일째`
 * 라벨은 Pretendard, 숫자는 SarasaGothicK mono + tabular-nums.
 * 라벨/숫자 분리와 `aria-label` 복구는 같은 창 푸터(TodaySealedFooter)와 같은 방식이다 —
 * span이 쪼개지면 스크린리더가 사이 공백 없이 붙여 읽으므로 문장을 따로 준다.
 * [Source: project_todaypage_daily_sealed_log_motif §시각 명세 갱신 2026-05-07]
 */
export function TodaySealedTitle({ entryNo, sol }: TodaySealedTitleProps) {
  const label = sol
    ? `오늘 일지 · ${entryNo}번째 · ${sol.label} ${sol.day}일째`
    : `오늘 일지 · ${entryNo}번째`;

  return (
    <span className={s.title} aria-label={label}>
      <span>오늘 일지</span>
      <span className={s.separator}>·</span>
      <span className={s.meta}>{entryNo}번째</span>
      {sol && (
        <>
          <span className={s.separator}>·</span>
          <span className={s.metaLabel}>{sol.label}</span>
          <span className={s.meta}>{sol.day}일째</span>
        </>
      )}
    </span>
  );
}
